import { useDialogStore } from '../store/dialog.store';

export function useDialogManager() {
  const openDialog = useDialogStore((state) => state.openDialog);

  return {
    openDialog,
  };
}
